import { useLocation } from "react-router-dom";
import { getVendorLoggedInDetails } from "../common/utility";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import Forbidden from "../pages/Forbidden";
import { Paths } from "../Routes/path";
import TrainingToolTip from "../components/molecules/TrainingToolTip";
import VendorHeader from "../components/molecules/VendorHeader";

const Vendor = ({ children, forbidden, user }) => {
  const { pathname } = useLocation();
  const loggedInUser = getVendorLoggedInDetails();
  useEffect(() => {
    const page = Object.values(Paths).find((item) =>
      item.path.includes(pathname)
    );
    page && page.type !== "tabs" && (document.title = page.title);
  }, [pathname]);

  return (
    <>
      <VendorHeader />
      {!forbidden && children}
      {!forbidden && !loggedInUser.UUID && (
        <TrainingToolTip pageTitle={document.title} />
      )}
      {forbidden && <Forbidden />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    forbidden: state.forbidden,
    user: state.userDetails,
  };
};

export default connect(mapStateToProps, null)(Vendor);
